import React from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import clsx from 'clsx'

import { LinkIconButton, LinkIconButtonProps } from './iconButton'
import Tooltip from './tooltip'

import { t } from 'i18n'
import { HistoryWithEntries } from 'utils'

const useStyles = makeStyles((theme) => ({
  root: {
    borderColor: theme.palette.grey[100],
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: theme.shape.borderRadius * 10,
    background: theme.palette.background.default,
    padding: theme.spacing(1),
    marginLeft: 0,
    boxShadow: '0px 2px 20px rgba(44, 41, 62, 0.1)',
    transition: theme.transitions.create('border-color'),
    '&:hover, &:focus': {
      borderColor: theme.palette.grey[200],
      background: theme.palette.background.default
    },
    '& .MuiSvgIcon-root': {
      width: '0.75em',
      height: '0.75em',
      fill: theme.palette.grey[300]
    }
  },
  dark: {
    borderColor: theme.palette.grey[200],
    background: theme.palette.grey[100],
    '&:hover, &:focus': {
      borderColor: theme.palette.grey[300],
      background: theme.palette.grey[100]
    }
  }
}))

interface BackButtonProps extends LinkIconButtonProps {
  dark?: boolean
  hardcodedBack?: boolean
}

const BackButton: React.FC<BackButtonProps> = ({ dark, to, className, hardcodedBack, ...props }) => {
  const classes = useStyles()
  const { entries, index, goBack } = useHistory() as HistoryWithEntries

  const previousEntry: any = entries[index - 1]

  const handleClick = (event: React.MouseEvent): void => {
    if (previousEntry === undefined) {
      return
    }

    event.preventDefault()

    goBack()
  }

  return (
    <Tooltip title={t('back')}>
      <LinkIconButton
        className={clsx(classes.root, className, { [classes.dark]: dark })}
        disableRipple
        color='transparent'
        onClick={hardcodedBack === true ? undefined : handleClick}
        to={hardcodedBack === true ? to : previousEntry?.pathname ?? to}
        {...props}
      >
        <ChevronLeftIcon />
      </LinkIconButton>
    </Tooltip>
  )
}

export default BackButton
